export interface PlayInOptions {
  endAt?: number
  initiatedBy?: string
  pausedAt?: number
  startAt?: number
}

export enum PlayInStatus {
  EMPTY = 'EMPTY',
  INACTIVE = 'INACTIVE',
  PAUSED = 'PAUSED',
  PLAYING = 'PLAYING',
  READY = 'READY',
}

export enum PlayInRemoteStatus {
  PAUSE_REQUESTED = 'PAUSE_REQUESTED',
  PLAY_REQUESTED = 'PLAY_REQUESTED',
  SEEK_REQUESTED = 'SEEK_REQUESTED',
  SEEK_COMPLETED = 'SEEK_COMPLETED'
}

export interface RemoteStatusRequestInterface {
  status: PlayInRemoteStatus
  requestId: number
  value?: number
  resumePlaying?: boolean
}

export interface PlayInObject {
  currentPos: number
  currentPosTimestamp: string
  endAt: number | null
  initiatedBy: string | null
  pausedAt: number | null
  remoteStatusRequest: RemoteStatusRequestInterface | null
  startAt: number
  status: PlayInStatus
  url?: string // deprecated: needed for backwards compatability on change to sources can be deleted on next
  sources: string[]
  latestAppliedRequest: number
}
